import React from 'react';
import { Check, Briefcase, Building2, ListChecks, ClipboardCheck, Award, Rocket } from 'lucide-react';

export const STEPS = [
  { n: 1, label: 'Job Title', hint: 'Position & basics', Icon: Briefcase },
  { n: 2, label: 'Company & Overview', hint: 'About the role', Icon: Building2 },
  { n: 3, label: 'Responsibilities', hint: 'Key duties', Icon: ListChecks },
  { n: 4, label: 'Requirements', hint: 'Must-have skills', Icon: ClipboardCheck },
  { n: 5, label: 'Qualifications', hint: 'Nice-to-have', Icon: Award },
  { n: 6, label: 'Complete', hint: 'Review & create', Icon: Rocket },
];

export function StepRail({ activeStep, isComplete, onGo }) {
  const done = STEPS.filter((s) => isComplete(s.n)).length;
  const pct = Math.round((done / STEPS.length) * 100);

  return (
    <div style={{ padding: '1.25rem 1.25rem 0.75rem', borderBottom: '1px solid #F1F5F9' }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '0.5rem' }}>
        <span style={{ fontSize: '0.625rem', fontWeight: 700, letterSpacing: '0.08em', textTransform: 'uppercase', color: '#64748B' }}>Progress</span>
        <span data-testid="jd-progress-text" style={{ fontFamily: 'JetBrains Mono, monospace', fontSize: '0.75rem', fontWeight: 700, color: '#0076A3' }}>{done} of {STEPS.length}</span>
      </div>
      <div style={{ height: 6, borderRadius: 999, background: '#EFF3F8', overflow: 'hidden', marginBottom: '1rem' }}>
        <div data-testid="jd-progress-bar" style={{ width: `${pct}%`, height: '100%', borderRadius: 999, background: 'linear-gradient(90deg,#0076A3,#00A0E0)', transition: 'width 0.35s ease' }} />
      </div>

      <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        {STEPS.map((s) => {
          const active = activeStep === s.n;
          const complete = isComplete(s.n);
          return (
            <button
              key={s.n}
              type="button"
              data-testid={`step-${s.n}-button`}
              onClick={() => onGo(s.n)}
              style={{
                display: 'flex', alignItems: 'center', gap: 10, width: '100%', textAlign: 'left',
                padding: '0.5rem 0.625rem', borderRadius: 10, cursor: 'pointer',
                border: '1px solid transparent',
                background: active ? '#E5EFFF' : 'transparent',
                transition: 'background-color 0.15s, border-color 0.15s',
              }}
            >
              <span style={{
                flexShrink: 0, width: 26, height: 26, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center',
                fontSize: '0.6875rem', fontWeight: 700,
                background: complete ? '#0D9488' : active ? '#0076A3' : '#EFF3F8',
                color: complete || active ? '#fff' : '#94A3B8',
              }}>
                {complete ? <Check size={14} /> : s.n}
              </span>
              <span style={{ minWidth: 0 }}>
                <span style={{ display: 'block', fontSize: '0.8125rem', fontWeight: 600, color: active ? '#0076A3' : '#002A38', lineHeight: 1.2 }}>{s.label}</span>
                <span style={{ display: 'block', fontSize: '0.6875rem', color: '#94A3B8' }}>{s.hint}</span>
              </span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
